import { InspectionListItem, InspectionStatus, getLocalDateString } from '../../../lib/inspections';

export interface MonthStats {
  total: number;
  scheduled: number;
  inProgress: number;
  completed: number;
  pendingRequests: number;
}

/**
 * 표시 중인 달(`monthPrefix` = `YYYY-MM`)에 속하는 점검만 추린다.
 *
 * 날짜 키는 `buildDaySummaryMap`과 같은 식(`scheduledAt ?? createdAt`의 로컬 날짜)으로 판다 —
 * 달력이 6월 셀에 그린 점검이 통계에서는 5월로 세지면 같은 화면이 두 숫자를 말하게 된다.
 * 주간 뷰는 앞뒤 달까지 프리페치하므로 이 필터가 없으면 "6월 요약"이 5·7월까지 합산한다.
 *
 * 범례 바 통계(`buildMonthStats`)와 월 요약 패널(`DayInspectionList`의 `MonthSummary`)이
 * 같은 화면에서 같은 달을 말해야 하므로 두 곳이 이 함수 하나를 쓴다.
 */
export function filterInspectionsToMonth(
  inspections: InspectionListItem[],
  monthPrefix: string,
): InspectionListItem[] {
  return inspections.filter((insp) => {
    const rawDate = insp.scheduledAt ?? insp.createdAt;
    return getLocalDateString(new Date(rawDate)).startsWith(`${monthPrefix}-`);
  });
}

/** 표시 중인 달의 점검 집계 (범례 바 우측 통계용). */
export function buildMonthStats(inspections: InspectionListItem[], monthPrefix: string): MonthStats {
  const stats: MonthStats = { total: 0, scheduled: 0, inProgress: 0, completed: 0, pendingRequests: 0 };

  for (const insp of filterInspectionsToMonth(inspections, monthPrefix)) {
    stats.total++;
    if (insp.status === InspectionStatus.SCHEDULED) stats.scheduled++;
    else if (insp.status === InspectionStatus.IN_PROGRESS) stats.inProgress++;
    else if (insp.status === InspectionStatus.COMPLETED) stats.completed++;
    if (insp.hasPendingScheduleChangeRequest === true) stats.pendingRequests++;
  }

  return stats;
}
